import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const formStyledCheckboxLabelCss = "f1uk6fce";
export const FormStyledCheckboxLabel = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(formStyledCheckboxLabelCss, props.className)} />;
});
const checkboxWrapperCss = "c5tyaod";
export const CheckboxWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(checkboxWrapperCss, props.className)} />;
});
const checkboxCopyWrapperCss = "c1unx477";
export const CheckboxCopyWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(checkboxCopyWrapperCss, props.className)} />;
});
const switchWrapperCss = "s8se771";
export const SwitchWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(switchWrapperCss, props.className)} />;
});
const sectionContentWrapperCss = "s17ln0ji";
export const SectionContentWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sectionContentWrapperCss, props.className)} />;
});
const sectionWrapperCss = "smkhe2o";
export const SectionWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} desktop-up={useDeviceType('isDesktopUp')} className={classNames(sectionWrapperCss, props.className)} />;
});
const sectionTitleWrapperCss = "sx4jiuh";
export const SectionTitleWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sectionTitleWrapperCss, props.className)} />;
});
const mobileSectionTitleWrapperCss = "mchqxc1";
export const MobileSectionTitleWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(mobileSectionTitleWrapperCss, props.className)} />;
});
const mobileSectionWrapperCss = "m1xmklce";
export const MobileSectionWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(mobileSectionWrapperCss, props.className)} />;
});
const titleWrapperCss = "t1kfzoev";
export const TitleWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(titleWrapperCss, props.className)} />;
});
const mobileTitleWrapperCss = "mwv359u";
export const MobileTitleWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(mobileTitleWrapperCss, props.className)} />;
});
const sectionRightContentRowCss = "s1ydnqw6";
export const SectionRightContentRow = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sectionRightContentRowCss, props.className)} />;
});
const connectedWrapperCss = "c1qkdb46";
export const ConnectedWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(connectedWrapperCss, props.className)} />;
});
const dropdownWrapperCss = "d1pgymv4";
export const DropdownWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dropdownWrapperCss, props.className)} />;
});
const dropdownErrorWrapperCss = "dgut0mr";
export const DropdownErrorWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dropdownErrorWrapperCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");